import { useSearchParams } from "react-router-dom";
import { Badge, Box, List, ListItemButton, ListItemText, useMediaQuery } from "@mui/material";
import { settings } from "app";
import CollectionSection from "../collections/CollectionSection";

// Selection lives in the URL so a link to a specific collection can be shared.
const WorkbenchLayout = ({ collections, curriculum }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const [searchParams, setSearchParams] = useSearchParams();

  const visible = collections.filter(
    collection => !collection.tenancies || collection.tenancies.includes(settings.tenant),
  );

  const requestedKey = searchParams.get("tab");
  const active = visible.find(collection => collection.key === requestedKey) ?? visible[0];

  const selectCollection = key => {
    setSearchParams(
      prev => {
        prev.set("tab", key);
        return prev;
      },
      { replace: true },
    );
  };

  if (!active) return null;

  const Section = active.Section ?? CollectionSection;
  // Half the visible collections per row, so the nav is two rows whatever the tenant hides.
  const columns = Math.ceil(visible.length / 2);

  return (
    <>
      <List
        component="nav"
        sx={{
          border: 1,
          borderColor: "divider",
          borderRadius: 1,
          py: 0,
          mb: 2,
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: `repeat(${columns}, 1fr)`,
          },
        }}
      >
        {visible.map(collection => (
          <ListItemButton
            key={collection.key}
            selected={collection.key === active.key}
            onClick={() => selectCollection(collection.key)}
          >
            <ListItemText
              primary={collection.label}
              primaryTypographyProps={{ fontSize: 14 }}
            />
            <Badge
              badgeContent={curriculum?.[collection.key]?.length ?? 0}
              color="primary"
              showZero
              sx={{ mr: 1.5 }}
            />
          </ListItemButton>
        ))}
      </List>

      <Box sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}>
        <Section
          key={active.key}
          collection={active}
        />
      </Box>
    </>
  );
};

export default WorkbenchLayout;
